<template>
    <div class="row filter">
        <div class="col-xs-12 col-sm-6 nopadding">
            <div class="form-group">
                <input type="text"
                       class="form-control centered-input-resp"
                       :placeholder="dish_search_placeholder"
                       v-model="selected_keyword"
                       @keyup.enter="MakeSearch"
                >
            </div><!-- /.form-group -->
        </div><!-- /.col-* -->

        <div class="col-xs-12 col-sm-6 nopadding">
            <div class="form-group">
                <div class="form-group">
                    <div class="restaurant-search">
                        <HereAddressLookup
                            @address="getAddressData"
                            id="dishCitySelect"
                            :placeholder="city_placeholder_trans"
                            :app_key="here_maps_key"
                            ref="city_input"/>
                    </div>
                </div><!-- /.form-group -->
            </div><!-- /.form-group -->
        </div><!-- /.col-* -->

        <div class="col-sm-6 col-xs-12 nopadding w-100">
            <div class="filter-actions pt-3">
                <div>
                    <div v-if="selected_keyword.length || address.locality || filters.length" class="filter-actions">
                        <a href="javascript:void(0)" @click="ResetForm">
                            <i class="lnr lnr-cross-circle"></i> {{ reset_trans }}
                        </a>
                    </div>
                </div>
                <div>
                    <button id="submit-search" type="button" class="btn btn-primary pull-right redefine-dishes-center"
                            v-text="search_button_trans" @click="MakeSearch"></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HereAddressLookup from '../components/HereAddressLookup.vue';

export default {
    props: {
        dish_search_placeholder: {
            type: String,
            required: true
        },
        city_placeholder_trans: {
            type: String,
            required: true
        },
        reset_trans: {
            type: String,
            required: true
        },
        search_button_trans: {
            type: String,
            required: true
        },
        php_search_keyword: {
            type: String,
            default: ''
        },
        php_search_city: {
            type: String,
            default: ''
        },
        build_search_route: {
            type: String,
            required: true
        },
        dishs_route: {
            type: String,
            required: true
        },
        here_maps_key: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            address: '',
            selected_keyword: '',
            filters: []
        }
    },
    components: {
        HereAddressLookup
    },
    methods: {
        getAddressData: function (addressData) {
            this.address = addressData;
        },

        ResetForm() {
            this.eventHub.$emit('reset_search');
            this.address = '';
            this.selected_keyword = "";
            $('#dishCitySelect').attr('placeholder', '');

            window.location.replace(this.dishs_route);
        },
        MakeSearch() {
            let VueInstance = this;

            if (VueInstance.selected_keyword.length || VueInstance.address.locality || VueInstance.filters.length) {
                axios.post(VueInstance.build_search_route, {
                    dish_search: VueInstance.selected_keyword,
                    search_city: VueInstance.address,
                    search_filters: VueInstance.filters
                })
                    .then(function (response) {
                        if (response.data.status === 'success') {
                            window.location.href = response.data.url;
                        } else if (response.data.status === 'not_supported') {
                            iziToast.show({
                                title: response.data.message,
                                color: response.data.code  // blue, red, green, yellow
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    },
    mounted() {
        if (this.php_search_keyword.length) {
            this.selected_keyword = this.php_search_keyword;
        }

        if (this.php_search_city.length) {
            this.address = JSON.parse(this.php_search_city);
            let recreated = this.address.locality;

            this.address.hasOwnProperty('route') ? recreated += ", " + this.address.route : "";

            this.$nextTick(() => {
                $('#dishCitySelect').val(recreated);
            });
        }
    },
    created() {
        this.eventHub.$on('toggle-filter', filters => {
            this.filters = filters;
        });

        this.eventHub.$on('search-event', () => {
            this.MakeSearch();
        });
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DishesSearch.vue